import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import Control from "lib/common/descriptorcontrols/Widget/button";
import PropTypes from "prop-types";
import React from "react";
import BaseFormItem from "../BaseFormItem";

export class Widgetvaluemutationbutton extends BaseFormItem {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e, d, v) {
        const { activeRecord, descriptor} = this.props;
        const config = descriptor.config;
        const processField = (record, fieldName) => {
            let info;
            try {
                info = entityFieldMetaStore.getInfo(record.entityKey, fieldName);
            } catch (e) {
                if (e.message.indexOf(fieldName) < 0) throw e;
                console.error(`Value mutation button '${descriptor.label}': ${e.message}`);
                return;
            }

            // We do not want to set a value on a disabled field.
            if (!record.isFieldEnabled(info)) return;

            let value = record.get(info);
            if (value == null) {
                value = "MISSING";
            }

            if (value === config.expectedValue.toUpperCase()) {
                this.doSetField(record, fieldName, config.newValue.toUpperCase());
            }
        };

        const processRecord = (rec) => {
            config.fieldNames.forEach(name => {
                processField(rec, name);
            });
        };

        if (config.collectionFieldName) {
            const target = activeRecord.get(config.collectionFieldName);
            target.forEach(r => processRecord(r));
        } else {
            processRecord(activeRecord);
        }
    }

    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        onClick={this.onClick}
                        onFocus={undefined}
                        onBlur={undefined}
                        enabled={!descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo)}
        />;
    }

}

Widgetvaluemutationbutton.propTypes = {
    ...Widgetvaluemutationbutton.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes(null, false)),
};

export default Widgetvaluemutationbutton;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Widget/valuemutationbutton.js